<template>
  <div>
    <aside class="menu is-size-3">
      <p class="account-name has-text-centered is-hidden-mobile">
        {{ account && account.name }}
      </p>
      <div class="is-hidden-tablet logo-container is-flex">
        <img
          v-if="$store.state.logos.length"
          class="mobile-logo image"
          :src="$store.state.logos[1]"
        >
        <img
          v-else
          src="../assets/white-logo.png"
          class="web-logo image"
          alt="webdotcom"
        >
      </div>
      <p class="menu-label first-item">
        {{ $t('sidebar.section.general') }}
      </p>

      <!-- *****  DOMAIN SECTION  ****** -->
      <ul class="menu-list">
        <sidebar-link
          :name="$t('sidebar.dashboard')"
          icon="tachometer-alt"
          :route="{name: 'MainSection'}"
        />
        <p
          v-show="hasRegisteredDomain"
          class="menu-label"
        >
          {{ $t('dashboard.domains.title') }}
        </p>
        <sidebar-link
          v-show="(hasPendingDomainSelection || hasPendingDomain) && domainAllowedStatus && domainData.isHidden === false && panelShowLogic('domainRegistration')"
          :name="$t('sidebar.domain_registration')"
          icon="globe"
          :route="{name: 'DomainRegistration'}"
        />
        <sidebar-link
          v-show="hasRegisteredDomain"
          :name="$t('sidebar.domains_overview')"
          icon="globe"
          :route="{name: 'MyDomains'}"
        />
        <!-- <sidebar-link
          name="listings"
          icon="tachometer-alt"
          :route="{name: 'Listings'}"
        /> -->
        <!-- <sidebar-link
          name="business-details"
          icon="tachometer-alt"
          :route="{name: 'BusinessDetails'}"
        /> -->

        <!-- <hr > -->
        <div v-if="!!services.website && getTenantConfig('showWebsiteByDIFM', isDifm) && websiteAllowedStatus">
          <p class="menu-label">
            {{ $t('dashboard.website.title') }}
          </p>
          <!--       <sidebar-link
            :name="$t('dashboard.website.edit')"
            icon="edit"
            :route="{ name: 'EditWebsite'}"
          /> -->
          <sidebar-link
            :name="$t('dashboard.website.mods')"
            icon="edit"
            :route="{ name: 'ModFormPage'}"
          />
          <!--    <sidebar-link
            :name="$t('dashboard.website.preview_link_text')"
            icon="image"
            :route="{ name: 'ViewWebsite'}"
          /> -->
        </div>
        <!-- <div v-if="!!services.email">
          <p class="menu-label">
            {{ $t('dashboard.email.title') }}
          </p>
          <sidebar-link
            :name="$t('dashboard.email.view_link_text')"
            icon="envelope"
            :route="{ name: 'ViewEmail'}"
          />
        </div> -->
        <p
          v-show="services.seo"
          class="menu-label"
        >
          {{ $t('dashboard.report.title') }}
        </p>
        <!--     <sidebar-link
          v-if="!!services.scorecard"
            :route="{ name: 'ModFormPage'}"
          :name="$t('dashboard.report.view_scorecard')"
          icon="chart-pie"
          :route="{ name: 'ViewScorecard'}"
        /> -->
        <!--  <sidebar-link
          v-if="!!services.payPerClick"
          :name="$t('dashboard.report.view_ppc')"
          icon="bullseye"
          :route="{ name: 'ViewPPC'}"
        /> -->
        <sidebar-link
          v-if="!!services.seo"
          :name="$t('dashboard.report.view_seo')"
          icon="search-location"
          :route="`/seoperformance/${services.seo}`"
        />

        <p
          v-show="panelShowLogic('businessProfile')"
          class="menu-label"
        >
          {{ $t('businessprofile.title.tag') }}
        </p>
        <sidebar-link
          v-show="panelShowLogic('businessProfile')"
          :name="$t('businessprofile.view.tag')"
          icon="address-card"
          route="/business-profile"
        />

        <p
          v-show="panelShowLogic('templatePicker')"
          class="menu-label"
        >
          {{ $t('templatepicker.title.tag') }}
        </p>
        <sidebar-link
          v-show="panelShowLogic('templatePicker')"
          :name="$t('templatepicker.subtitle.tag')"
          icon="images"
          route="/template-picker"
        />
        <!-- <sidebar-link

          name="no service test"
          icon="search-location"
          route="/no-service"
        /> -->
        <!--  <p class="menu-label">
          Test routes
        </p> -->
        <!--  <sidebar-link
          name="Modal Test Page"
          icon="desktop"
          route="/modal-test-page"
        /> -->
        <!-- <sidebar-link
          name="Test Wizard"
          icon="desktop"
          route="/test-wizard-form"
        /> -->
        <!--    <sidebar-link
          name="Test Query"
          icon="desktop"
          route="/test-query"
        /> -->
        <!--  <sidebar-link
          name="Test Modify"
          icon="desktop"
          route="/test-modify"
        /> -->
      </ul>
    </aside>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import SidebarLink from './SidebarLink.vue'
import tenantConfigMixin from '@/mixins/tenant-config'
import businessProfileMixin from '@/mixins/business-profile'
import siteplusMixins from '@/mixins/siteplus-generated-urls'

export default {
  name: 'SidebarContent',
  components: {
    SidebarLink
  },
  mixins: [
    tenantConfigMixin,
    businessProfileMixin,
    siteplusMixins
  ],
  computed: {
    ...mapState(['services', 'account', 'skipBusinessProfile']),
    ...mapState('domainService', ['domainData']),
    ...mapGetters('domainService', ['domainAllowedStatus', 'hasRegisteredDomain', 'hasPendingDomainSelection', 'hasPendingDomain']),
    ...mapGetters('websiteService', ['isDifm', 'websiteAllowedStatus'])
  },

  methods: {

    serviceProperty (service, field) {
      if (typeof service !== 'undefined' && Object.prototype.hasOwnProperty.call(service, field)) {
        return service[field]
      }
      return false
    },

    serviceStatusAllowed (service) {
      if (typeof service !== 'undefined' && Object.prototype.hasOwnProperty.call(service, 'status') && service.status !== '') {
        return ['Active', 'Suspended'].includes(service.status)
      }
      return true
    },

    panelShowLogic (panel) {
      switch (this.getTenantEnv()) {
        case 'FCR_PROD':
        case 'FCR_QA':
          return this.panelLogicFCR(panel)

        case '1800_PROD':
        case '1800_QA':
            return this.panelLogic1800(panel)

        case 'BT_PROD':
        case 'BT_QA':
          return this.panelLogicBT(panel)

        case 'TIDE_PROD':
        case 'TIDE_QA':
          return this.panelLogicTIDE(panel)

        default:
          return this.panelLogicWEB(panel)
      }
    },

    panelLogicBT (panel) {
      switch (panel) {
        case 'domainRegistration':

          if (this.profileWasUpdated || this.$store.state.skipBusinessProfile) {
            return true
          }
          break

        case 'templatePicker':

          if (!this.getTenantConfig('hideService', 'templatePicker') &&
              this.serviceStatusAllowed(this.siteplusWebsiteDetails) && this.serviceProperty(this.siteplusWebsiteDetails, 'domainName') &&
              this.serviceProperty(this.siteplusWebsiteDetails, 'serviceState') &&
              this.serviceProperty(this.siteplusWebsiteDetails, 'serviceState') !== 'UpdatingSubscription' &&
              !this.serviceProperty(this.siteplusWebsiteDetails, 'hasTemplate')) {
            return true
          }

        break

        default:
          return true
      }
    },

    panelLogicFCR (panel) {
      switch (panel) {
        case 'businessProfile':
          if (!this.getTenantConfig('hideService', 'businessProfileSidebar')) {
            return true
          }
          break

        case 'templatePicker':
          return false

        default:
          return true
      }
    },

    panelLogicTIDE (panel) {
      switch (panel) {
        case 'businessProfile':
          if (!this.getTenantConfig('hideService', 'businessProfileSidebar')) {
            return true
          }
          break

        case 'templatePicker':
          return false

        default:
          return true
      }
    },

    panelLogic1800(panel) {

        switch (panel) {

            case 'businessProfile':
                return false
                break

            case 'templatePicker':
                return false
                break

            default:
                return true
        }
    },

    panelLogicWEB (panel) {
      switch (panel) {
        case 'businessProfile':
          if (!this.getTenantConfig('hideService', 'businessProfileDashboard')) {
            return true
          }
          break

        case 'templatePicker':
          return false

        default:
          return true
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../sass/_variables.scss";
$mini-sidebar-margin: 5px;

.logo-container {
  justify-content: center;
  background-color: var(--tertiary-color);
  padding: 10px;
}
.mobile-logo {
  max-width: 100px;
  max-height: 100px;
}
.web-logo {
  padding-top: 15px;
  max-width: 100px;
  max-height: 100px;
}
.account-name {
  overflow: hidden;
  font-size: 0.7em;
  padding-left: 10px;
  transition: all $animation-fast;
  position: relative;
  // background: var(--tertiary-color);
  background: var(--primary-color);

  padding: 10px;
}
.menu-label {
  overflow: hidden;
  font-size: 0.7em;
  padding-left: 10px;
  max-height: 20px;
  transition: all $animation-fast;
  position: relative;
  margin-bottom: 0.5em;
  margin-top: 0.5em;

  &.first-item {
    margin-top: 1em;
  }

  &:after {
    content: "";
    position: absolute;
    top: 0;
    width: $sidebar-icon-width - ($mini-sidebar-margin * 2);
    right: $mini-sidebar-margin;
    transition: all $animation-fast;
    border-bottom: solid #8e8e8e00 1px;
  }
}

.mini {
  .account-name {
    opacity: 0;
  }
  .menu-label {
    &:not(.first-item) {
      &:after {
        border-bottom: 1px solid #7a7a7a;
      }
      max-height: 1px;
    }
  }
}

@media only screen and (max-width: $break-small) {
  .mini {
    .menu-label {
      &:not(.first-item) {
        &:after {
          border-bottom: none;
        }
        max-height: 20px;
      }
    }
  }
}
</style>
